/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, October 11th 2021, 1:49:29 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder, validateInternalCSS } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";

export enum LAYOUT_OPTIONS {
  general = "General",
  document = "Document",
  detail_display = "Detail Display",
  list_display = "List Display",
  qr_code = "QR Code",
  email = "Email",
}

export interface DesignLayout extends ProcessTemplateArtifact, WritableModel<false> {
  title: string;
  html_design: string;
  layout_type: keyof typeof LAYOUT_OPTIONS;
  css: string;
  active: boolean;
}

export const DesignLayoutValidationSchema: ProcessTemplateArtifactSchemaType<DesignLayout> =
  ProcessTemplateArtifactValidationSchema.shape({
    id: schemaBuilder.number().positive().nullable(),
    title: schemaBuilder.string().required("The Title for the layout is required."),
    html_design: schemaBuilder.string().required("The HTML Design for the layout is required."),
    layout_type: schemaBuilder.mixed().oneOf(Object.keys(LAYOUT_OPTIONS)).required("Layout type is required"),
    css: schemaBuilder
      .string()
      .required("CSS is required")
      .default("")
      .test(
        "internal-css-test",
        "CSS ERROR: `body` and `html` text are not allowed in your css. Kindly rename them.",
        validateInternalCSS
      ),
    active: schemaBuilder.boolean(),
  });
